import React from 'react';
import { Carousel } from 'antd';

const legacyImageContext = require.context(
  '../../../../Assets/Linkages/SpaceDestinationSchools/Introduction',
  false,
  /\.jpg$/i,
);

const legacyImages = legacyImageContext.keys().sort().map((key) => {
  const image = legacyImageContext(key);
  return image.default || image;
});

const SpaceDestinationLegacy = () => (
  <section className="space-destination-legacy" aria-labelledby="space-destination-legacy-title">
    <div className="space-destination-legacy-inner">
      <header className="space-destination-legacy-header">
        <p className="section-eyebrow">SPACE EDUCATION ACROSS PAKISTAN</p>
        <h2 id="space-destination-legacy-title">Our Legacy</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>

      <p className="space-destination-legacy-copy">
        The Space Destination Schools initiative has become a pioneering model for grassroots space
        education in Pakistan, inspiring curiosity and scientific thinking among students in remote
        and underserved areas. By transforming host schools into temporary space learning hubs, the
        program has created memorable learning experiences for over 2,000 students from 150+ schools
        across multiple regions. Its hands-on, inclusive approach continues to ignite young minds and
        lay the foundation for a future generation of space enthusiasts and innovators.
      </p>

      <Carousel
        className="space-destination-legacy-carousel"
        autoplay
        autoplaySpeed={3400}
        pauseOnHover
        dots
        slidesToShow={3}
        slidesToScroll={1}
        responsive={[
          { breakpoint: 1100, settings: { slidesToShow: 2 } },
          { breakpoint: 700, settings: { slidesToShow: 1 } },
        ]}
      >
        {legacyImages.map((src, index) => (
          <div className="space-destination-legacy-slide" key={src}>
            <figure>
              <img
                src={src}
                alt={`Space Destination Schools legacy activity ${index + 1}`}
                loading="lazy"
              />
            </figure>
          </div>
        ))}
      </Carousel>
    </div>
  </section>
);

export default SpaceDestinationLegacy;
